import { isValid } from '@pages/Client/Calendar/components/BulkEdit/helpers/isValidValidationNumber';

export function validateNoDecimals(value?: number | null) {
  return isValid(value) ? Number(value) % 1 === 0 : true;
}
